var exports = {
  "Q": "repositoriesListWrapper__mSK3Et",
};

module.exports = exports;
